<template>
    <button
        type="button"
        class="kgr-table__action"
        :disabled="disabled"
        style="position: relative;"
        @click="$emit('sendDunning')"
    >
        <kgr-icon
            icon-class="email"
            :title="title"
            :disabled="disabled"
            :style="disabled ? {} : { color: '#2196f3' }"
        />
        <i
            v-if="emailPrepared"
            class="kgr-indicator is-success dot"
            :class="emailSent ? 'finished' : 'running'"
        >
        </i>
    </button>
</template>

<script>
import ClubInvoice from '../../../js/dto/ClubInvoice.js';
import Helper from '../../../js/accounting/Helper.js';
import Icon from '../../common/icon/Icon.vue';

export default {
    components: {
        'kgr-icon': Icon,
    },
    props: {
        invoice: {
            type: ClubInvoice,
            required: true,
        },
        dunningLevel: {
            type: Number,
            required: true,
        },
    },
    computed: {
        emailPrepared() {
            return this.invoice.dunningPdfs[this.dunningLevel].lastEmailSent !== null;
        },
        emailSent() {
            return this.invoice.dunningPdfs[this.dunningLevel].lastEmailSent === true;
        },
        title() {
            if (this.invoice.invoiceRecipient.email === null) {
                return this.$t('Keine E-Mail-Adresse hinterlegt');
            }
            if (!this.invoice.dunningPdfs[this.dunningLevel].pdfExists) {
                return this.$t('Das PDF wird erstellt');
            }
            if (this.invoice.dunningPdfs[this.dunningLevel].lastEmailSent === false) {
                return this.$t('Das PDF wird gerade verschickt.');
            }
            const dunningType = new Helper().translateDunningStatus(this.dunningLevel);
            return this.invoice.dunningPdfs[this.dunningLevel].lastEmailSent
                ? `${dunningType} als E-Mail verschicken\n\nLetztes Mal verschickt am ${
                    this.formatDate(this.invoice.dunningPdfs[this.dunningLevel].lastEmailDate)}`
                : `${dunningType} als E-Mail verschicken`;
        },
        disabled() {
            return this.invoice.invoiceRecipient.email === null
                || this.invoice.dunningPdfs[this.dunningLevel].pdfExists === false;
        },
    },
    methods: {
        formatDate(date) {
            return new Helper().formatDate(date);
        },
    },
};
</script>

<style>
    div.pdf-email-icon {
    margin-right: 15px;
}
.dot {
    height: 7px;
    width: 7px;
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: 0;
}
.finished {
    background-color: #00ff00;
}
.running {
    background-color: #afafaf;
}
</style>
